<script lang="ts">

    import {entityStore} from "../stores.js";

    export let title = "";

    export let stepKey;

    export let disabled = true;

    export let expanded = false;


    let active = false;

    let stepIndex;

    let step;

    $:{
        step = $entityStore.steps.find(s => s.key == stepKey);
        stepIndex = $entityStore.steps.findIndex(s => s.key == stepKey);
        disabled = step.disabled;
        active = step.isActive;
        console.log("expanded step = " + step.key + " ?? => ", expanded);
    }

    function checkExpanded() {

        if (expanded) {
            return true
        } else {
            return active;
        }
    }


    function toggleDropdown(e: Event) {
        console.log("toggle");
        e.preventDefault();
        e.stopPropagation();
        //ignore if disabled:
        /*
        if(disabled)
            return;
        */
        expanded = !expanded;

        let tmpSteps = $entityStore.steps;
        tmpSteps[stepIndex].expanded = expanded;
        entityStore.update($entityStore => ({
            ...$entityStore,
            steps: [...tmpSteps],
        }));
    }

    /*
    $: {

        if(expanded){

            expanded = false;
        }else{
            console.log("toggle expanded from false to true")
            expanded = true;
        }

    }
*/


</script>

<!-- toggle if you click anywhere in the whole component
<svelte:window on:click={() => expanded = false}/>
-->

<div class="accordion-wrapper" class:disabled={disabled} class:active={active}>
    <span class="accordion-el" class:expanded={expanded || active}>
        <div class="accordion-title" on:click={toggleDropdown}>{title}</div>
        <div class="accordion-content">
            <slot name="content"></slot>
        </div>
    </span>
</div>
<style lang="scss">


    .accordion-wrapper {
        margin: 0;
        padding: 0;
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 3rem;
    }

    .accordion-wrapper * {

        margin: 0;

    }

    .accordion-el {
        // margin-top: 5px;
        border-radius: 10px;
        width: 100%;
        //position: absolute;
        display: inline-block;
        /*font-size: x-large;*/
        font-weight: normal;
        min-height: auto; //4em too much...
        max-height: 1em;
        overflow: hidden;
        //top: 0.5em;
        cursor: pointer;
        text-align: left;
        white-space: nowrap;
        color: #474747;
        outline: none;
        background-color: #FFFFFF;
        transition: 0.3s all ease-in-out;
        z-index: 99;
        //background-color:lightgreen;
        padding: 10px;
        padding-right: 2rem;
        padding-left: 2rem;
        padding-bottom: 2rem;
    }

    .accordion-el input:focus + label {
        background: #def;
    }

    .accordion-el input {
        width: 1px;
        height: 1px;
        display: inline-block;
        position: absolute;
        opacity: 0.01;
    }

    .accordion-el label {
        display: block;
        height: 2.5em;
        line-height: 2em;
        padding-left: 1em;
        padding-right: 3em;
        cursor: pointer;
        position: relative;
        transition: 0.3s color ease-in-out;

    }

    .accordion-el label:nth-child(2) {
        margin-top: 2em;
    }

    .accordion-el input:checked + label {
        display: block;
        border-top: none;
        position: absolute;
        top: 0;
        width: 100%;
    }

    .accordion-el input:checked + label:nth-child(2) {
        margin-top: 0;
        position: relative;

    }

    .accordion-el::after {
        // content: "";
        position: absolute;
        //right: 2.3em;
        right: 0em;
        margin-right: -2rem;
        top: 0;
        line-height: 4rem;
        //  border: 0.3em solid #777777;
        // border-color: #777777 transparent transparent transparent;
        content: url("data:image/svg+xml,%3Csvg width='13' height='8' viewBox='0 0 13 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.81322 7.72701L0.286495 2.46079C-0.095499 2.09681 -0.0954989 1.50823 0.286496 1.14811L1.20491 0.272991C1.5869 -0.0909968 2.2046 -0.0909967 2.58253 0.272992L6.5 4.00581L10.4175 0.272993C10.7995 -0.0909952 11.4172 -0.0909951 11.7951 0.272993L12.7135 1.14811C13.0955 1.5121 13.0955 2.10068 12.7135 2.4608L7.18678 7.72701C6.81291 8.091 6.19522 8.091 5.81322 7.72701Z' fill='%23054055'/%3E%3C/svg%3E");
        transform: rotate(360deg);
        transition: 0.4s all ease-in-out;
    }

    .accordion-el.expanded {
        //padding: 0;
        //box-shadow: rgba(0, 0, 0, 0.1) 3px 3px 5px 0;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        // min-height: 15em;
        height: auto;
        min-height: 4em;
        max-height: 1000em;
        overflow: visible;
        cursor: default;

    }

    .accordion-el.expanded label:hover {
        color: #3694d7;
    }

    .accordion-el.expanded input:checked + label {
        color: #3694d7;
    }

    .accordion-el.expanded::after {
        transform-origin: center;
        transform: rotate(180deg);
        //top: 0.55em;

    }

    .accordion-title {
        //height: 32px;
        font-size: 20px;
        font-weight: 700;
        width: 100%;
        position: absolute;
        z-index: 101;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .accordion-content {
        margin-top: 70px;
        white-space: pre-wrap;
    }

    .accordion-wrapper.disabled {
        opacity: 0.5;
    }

    .accordion-wrapper.active {
        .accordion-el::after {
            visibility: hidden;
        }
    }

    .accordion-wrapper.disabled .accordion-el:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: calc(100% + 4rem);
        height: 100%;
        //background-color: rgba(255, 0, 0, 0.45); enable for a surprise :D
        z-index: 100;
    }

</style>
